import * as React from 'react';
import { cn } from '../../lib/utils';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'accent' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    const variantStyles = {
      default: 'border-2.5 border-ink bg-ink text-paper shadow-hard-ink press',
      accent: 'border-2.5 border-ink bg-marker text-ink shadow-hard press',
      destructive: 'border-2.5 border-ink bg-wrong text-ink shadow-hard press',
      outline: 'border-2.5 border-ink bg-cream text-ink shadow-hard press',
      secondary: 'border-2.5 border-ink bg-cream text-ink shadow-hard press',
      ghost: 'border-2.5 border-transparent bg-transparent text-ink hover:bg-track',
      link: 'text-ink underline decoration-marker decoration-2 underline-offset-4 hover:decoration-4',
    };

    const sizeStyles = {
      default: 'h-12 px-5 rounded-[14px] text-base',
      sm: 'h-10 px-3.5 rounded-tile text-sm',
      lg: 'h-14 px-7 rounded-[16px] text-base',
      icon: 'h-11 w-11 rounded-[14px]',
    };

    return (
      <button
        className={cn(
          'inline-flex items-center justify-center gap-2 whitespace-nowrap font-bold transition-colors disabled:pointer-events-none disabled:opacity-50',
          sizeStyles[size],
          variantStyles[variant],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };
